import React from 'react'

export default function ShirtsIcon() {
  return <img src='assets/shirts-icon.png' alt='Operations Logo' height={70} />
}
